import moment from 'moment'

export const availabilityRequestDate = (value, minimumNoticeMinutes = 0) => {
  const requestedDay = moment(value).startOf('day')
  const notice = Number(minimumNoticeMinutes)
  const earliest = moment().add(Number.isFinite(notice) ? Math.max(0, notice) : 0, 'minutes')
  const requestStart = requestedDay.isAfter(earliest) ? requestedDay : earliest

  return requestStart.format('YYYY-MM-DD HH:mm')
}

export const parseNextAvailabilityDate = (value) => {
  const parsed = moment(value, 'YYYY-MM-DD HH:mm:ss', true)

  return parsed.isValid() ? parsed : null
}
